import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

class AddableRow extends Component {
	state = {
		isMouseOver: false
	}

	onRowMouseOver = () => {
		this.setState({
			isMouseOver: true
		});
	}

	onRowMouseLeave = () => {
		this.setState({
			isMouseOver: false
		});
	}

	removeRow = e => {
		e.preventDefault();

		this.props.onRemove(this.props.rowKey);
	}

	render () {
		const { isMouseOver } = this.state;
		const { children, showDeleteAction } = this.props;

		return <div className={cn('row addable with-select', { 'hover-state': isMouseOver })} onMouseOver={this.onRowMouseOver} onMouseLeave={this.onRowMouseLeave}>
			{children}
			{
				isMouseOver && showDeleteAction ?
					<button className="remove-button" type="button" onClick={this.removeRow}><i className="fi flaticon-remove"></i></button>
					: null
			}
		</div>
	}
}

AddableRow.propTypes = {
	children: PropTypes.node,
	onRemove: PropTypes.func.isRequired,
	rowKey: PropTypes.any,
	showDeleteAction: PropTypes.bool
};

export default AddableRow;



// WEBPACK FOOTER //
// ./components/ClientForm/AddableRow.js